import React, { useState } from "react";
import { loginlogo } from "../../imagepath";
import { requestResetPassword, validateResetPassword } from "../../HttpRequest/afterlogin";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const ForgotPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState({
    emailid: "",
    error: "",
    data: {},
    emailvaild: false,
    emailToken: "",
    password: "",
    confirmpassword: "",
  });

  const [step, setStep] = useState(1);

  const handlechange = (event) => {
    const { name, value } = event.target;
    setEmail({
      ...email,
      [name]: value,
    });
  };

  const handleEmailSubmit = async () => {
    try {
      const response = await requestResetPassword({
        toMails: [email.emailid],
      });

      console.log("Response==>", response);

      if (response.status === 200) {
        setStep(2); // Move to the next step (OTP and Password)
      } else {
        setEmail({
          ...email,
          error: "Failed to send OTP email. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error sending OTP email:", error);
      setEmail({
        ...email,
        error: "An error occurred. Please try again.",
      });
    }
  };

  const handleResetPasswordSubmit = async () => {
    try {
      if (email.password !== email.confirmpassword) {
        setEmail({
          ...email,
          error: "New password and confirm password do not match.",
        });
        return;
      }

      const response = await validateResetPassword({
        resetToken: email.emailToken,
        newPassword: email.password,
      });

      console.log("Response==>", response);

      if (response && response.status === 200) {
        history.push('/');
        console.log("Password reset successfully!");
      } else {
        setEmail({
          ...email,
          error: "Failed to reset password. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setEmail({
        ...email,
        error: "An error occurred. Please try again.",
      });
    }
  };

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
                <img className="img-fluid" src={loginlogo} alt="Logo" />
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  {step === 1 && (
                    <div>
                      <h1>Reset Password</h1>
                      <p className="account-subtitle">Let Us Help You</p>
                      <div className="form-group">
                        <label>
                          Email address <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="emailid"
                          value={email.emailid}
                          onChange={handlechange}
                        />
                        <span className="profile-views">
                          <i className="fas fa-envelope" />
                        </span>
                      </div>
                      {email.error && (
                        <div className="errormessage">{email.error}</div>
                      )}
                      <div className="form-group">
                        <button
                          className="btn btn-primary btn-block"
                          type="button"
                          onClick={handleEmailSubmit}
                        >
                          Send OTP Email
                        </button>
                      </div>
                    </div>
                  )}

                  {step === 2 && (
                    <div>
                      <h1>Reset Password</h1>
                      <p className="account-subtitle">
                        Enter OTP and New Password
                      </p>
                      <div className="form-group">
                        <label>
                          OTP <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="emailToken"
                          value={email.emailToken}
                          onChange={handlechange}
                        />
                        {/* {email.error && (
                          <div className="errormessage">{email.error}</div>
                        )} */}
                      </div>
                      <div className="form-group">
                        <label>
                          New Password <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="password"
                          name="password"
                          value={email.password}
                          onChange={handlechange}
                        />
                      </div>
                      <div className="form-group">
                        <label>
                          Confirm Password{" "}
                          <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="password"
                          name="confirmpassword"
                          value={email.confirmpassword}
                          onChange={handlechange}
                        />
                      </div>
                      {email.error && (
                        <div className="errormessage">{email.error}</div>
                      )}
                      <div className="form-group">
                        <button
                          className="btn btn-primary btn-block"
                          type="button"
                          onClick={handleResetPasswordSubmit}
                        >
                          Reset Password
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
